/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TypDaty {
  DostepnyPo = 'DOSTEPNY_PO',
  Opublikowany = 'OPUBLIKOWANY',
  Stworzony = 'STWORZONY',
  Uzyskany = 'UZYSKANY',
  Otrzymany = 'OTRZYMANY',
  Wyslany = 'WYSLANY',
  Zaakceptowany = 'ZAAKCEPTOWANY',
  Zatwierdzony = 'ZATWIERDZONY',
  Zmodyfikowany = 'ZMODYFIKOWANY',
  DatySkrajne = 'DATY_SKRAJNE',
  Zdarzenia = 'ZDARZENIA',
  Waznosci = 'WAZNOSCI',
  Odrzucony = 'ODRZUCONY',
  Inna = 'INNA'
}
